module.exports = __webpack_public_path__ + "img/11d.6eb0df91.jpg";